import { Component, Input } from '@angular/core';
import { NoKpiProject } from '../../../../shared/brands.model';
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-research-impact-banner',
  templateUrl: './research-impact-banner.component.html',
  styleUrls: ['./research-impact-banner.component.scss']
})
export class ResearchImpactBannerComponent {
  index = 0;
  @Input() noKpiProject: NoKpiProject;
  @Input() styles: string;


  constructor(private languageService: LanguageService) {
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }
}
